import { FC } from 'react';
import { MobileBottomBar } from '@app/layout/mobile-bottom-bar.tsx';
import { DesktopNavbar } from '@app/layout/desktop-navbar.tsx';
import { MobileNavbar } from '@app/layout/mobile-navbar.tsx';
import { MobileContent } from '@app/layout/mobile-content.tsx';
import { useBootstrap } from '../../entites/app/use-bootstrap.ts';
import { DesktopContent } from '@app/layout/desktop-content.tsx';
import { useMediaQuery } from '@uidotdev/usehooks';
import { DesktopFooter } from '@app/layout/desktop-footer.tsx';

export const Layout: FC = () => {
  useBootstrap();

  const isMobile = useMediaQuery('only screen and (max-width : 1023px)');

  return isMobile ? (
    <>
      <MobileNavbar />

      <MobileContent />

      <MobileBottomBar />
    </>
  ) : (
    <>
      <DesktopNavbar />

      <DesktopContent />

      <DesktopFooter />
    </>
  );
};
